import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { hotMovies } from '@/mocks/movies';

export default function HeroBanner() {
  const [current, setCurrent] = useState(0);
  const count = hotMovies.length;

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % count);
  }, [count]);

  useEffect(() => {
    const timer = setInterval(next, 5000);
    return () => clearInterval(timer);
  }, [next]);

  const movie = hotMovies[current];

  return (
    <section className="relative w-full h-[480px] md:h-[620px] overflow-hidden" aria-label="电影轮播">
      {hotMovies.map((m, index) => (
        <div
          key={m.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            index === current ? 'opacity-100' : 'opacity-0 pointer-events-none'
          }`}
        >
          <img
            src={m.banner}
            alt={m.title}
            className="w-full h-full object-cover object-top"
          />
        </div>
      ))}

      <div className="absolute inset-0 bg-gradient-to-r from-background-950/85 via-background-950/50 to-background-950/85"></div>
      <div className="absolute inset-0 bg-gradient-to-t from-background-50 via-transparent to-transparent"></div>

      <div className="absolute bottom-0 left-0 right-0">
        <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6 pb-12 md:pb-16">
          <div className="flex items-end justify-between">
            <div className="max-w-xl" key={movie.id}>
              <div className="flex items-center gap-3 mb-3">
                <span className="px-2.5 py-1 rounded-full bg-primary-500/20 text-primary-400 text-xs font-semibold whitespace-nowrap">
                  {movie.category}
                </span>
                <span className="px-2.5 py-1 rounded-full bg-accent-500/20 text-accent-400 text-xs font-semibold whitespace-nowrap">
                  热播推荐
                </span>
              </div>
              <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-50 mb-2">
                {movie.title}
              </h2>
              <p className="text-sm md:text-base text-foreground-300 mb-4 leading-relaxed line-clamp-2">
                {movie.description}
              </p>
              <div className="flex items-center gap-4 mb-5">
                <div className="flex items-center gap-1.5">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-star-fill text-primary-500"></i>
                  </div>
                  <span className="text-sm font-semibold text-foreground-100">{movie.rating}</span>
                </div>
                <span className="text-sm text-foreground-500">{movie.duration}</span>
                <span className="text-sm text-foreground-500">{movie.year}</span>
              </div>
              <div className="flex items-center gap-3">
                <Link
                  to={`/movie/${movie.id}`}
                  className="inline-flex items-center gap-2 px-6 py-2.5 whitespace-nowrap rounded-full bg-primary-500 text-background-950 font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer"
                >
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-play-fill"></i>
                  </div>
                  立即播放
                </Link>
                <Link
                  to={`/category/${movie.categorySlug}`}
                  className="inline-flex items-center gap-2 px-6 py-2.5 whitespace-nowrap rounded-full border border-foreground-400/40 text-foreground-200 text-sm hover:border-foreground-300 hover:text-foreground-50 transition-colors cursor-pointer"
                >
                  更多{movie.category}
                </Link>
              </div>
            </div>

            <div className="hidden md:flex items-center gap-2">
              {hotMovies.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrent(index)}
                  className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                    index === current
                      ? 'w-6 bg-primary-500'
                      : 'bg-foreground-500/40 hover:bg-foreground-400/60'
                  }`}
                  aria-label={`切换到第 ${index + 1} 张`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      <button
        onClick={() => setCurrent((current - 1 + count) % count)}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-full bg-background-950/40 text-foreground-200 hover:bg-background-950/60 hover:text-foreground-50 transition-colors cursor-pointer"
      >
        <i className="ri-arrow-left-s-line text-xl"></i>
      </button>

      <button
        onClick={next}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center rounded-full bg-background-950/40 text-foreground-200 hover:bg-background-950/60 hover:text-foreground-50 transition-colors cursor-pointer"
      >
        <i className="ri-arrow-right-s-line text-xl"></i>
      </button>
    </section>
  );
}